export const UserTypes = Object.freeze({
    ACADEMIC: 1,
    STUDENT: 2,
    COORDINATOR: 4,
    MANAGER: 5,
    getUserTypeOptions : (gW: (key: string) => string) => [
        {
            label: gW("academic"),
            value: Number(UserTypes.ACADEMIC),
        },
        {
            label: gW("student"),
            value: Number(UserTypes.STUDENT),
        },
        {
            label: gW("coordinator"),
            value: Number(UserTypes.COORDINATOR),
        },
        {
            label: gW("manager"),
            value: Number(UserTypes.MANAGER),
        },
    ],

    getUserTypeLabel : (value:  number) => {
        const stringValue = value;
        switch (stringValue) {
            case UserTypes.ACADEMIC: return "academic";
            case UserTypes.STUDENT: return "student";
            case UserTypes.COORDINATOR: return "coordinator";
            case UserTypes.MANAGER: return "manager";
            default: return "unknown";
        }
    }
});
